/**
 * Action history tracker for debugging analysis tool issues.
 *
 * A lot of analysis issues are hard to find the root cause of like "Expected view to exist" assertion errors.
 * This is because state of the ui and application is stored in many places and there isn't just one simple
 * place we can log. This tool is met to add additional context to these errors to try and pinpoint the series
 * of events that caused the error.
 */

interface AnalysisActionHistoryEntry {
  action: string;
  timestamp: number;
  data?: Record<string, unknown>;
}

const MAX_HISTORY_SIZE = 20;
const analysisActionHistory: Array<AnalysisActionHistoryEntry> = [];

export function recordAnalysisAction(action: string, data?: Record<string, unknown>): void {
  analysisActionHistory.push({
    action,
    timestamp: Date.now(),
    data,
  });

  if (analysisActionHistory.length > MAX_HISTORY_SIZE) {
    analysisActionHistory.shift();
  }
}

export function getAnalysisActionHistory(): Array<AnalysisActionHistoryEntry> {
  return [...analysisActionHistory];
}

export function clearAnalysisActionHistory(): void {
  analysisActionHistory.length = 0;
}
